module.exports = __webpack_public_path__ + "img/alwayspay.2a3d97ff.png";